import cn from 'classnames';
import React from 'react';

import styles from './nav-list.module.scss';

export type NavListItemProps = React.LiHTMLAttributes<HTMLLIElement>;

const Item: React.FC<NavListItemProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <li className={cn(styles.item, className)} {...props}>
      {children}
    </li>
  );
};

/**
 * Main menu list.
 */
const NavList: React.FC<React.HTMLAttributes<HTMLUListElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <ul className={cn(styles.container, className)} {...props}>
      {children}
    </ul>
  );
};

export default Object.assign(NavList, { Item });
